import { render, staticRenderFns } from "./BlockCTAHero.vue?vue&type=template&id=2c20b786&"
import script from "./BlockCTAHero.vue?vue&type=script&lang=js&"
export * from "./BlockCTAHero.vue?vue&type=script&lang=js&"
import style0 from "./BlockCTAHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports